import Navbar from "./components/navbar/Navbar";
import Login from "./pages/login/Login";
import ResetPass from "./pages/resetPass/ResetPass";
import Dashboard from "./pages/dashboard/Dashboard";
import TasksList from "./pages/tasksList/TasksList";
import Detail from "./pages/detail/Detail";
import ConfirmPass from "./pages/confirmPassword/ConfirmPass";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSelector } from "react-redux";
import AuthenticateRoute from "./helpers/AuthenticateRoute";

function App() {
  const { currentUser } = useSelector((state) => state.user);
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route exact path="/" element={<Login />} />
          {/* <Route exact path="*" element={<Login />} /> */}
          <Route path="/reset-password" element={<ResetPass />} />
          <Route path="/confirmpass" element={<ConfirmPass />} />
          <Route
            path="/atf-dashboard"
            element={
              <AuthenticateRoute>
                <Dashboard />
              </AuthenticateRoute>
            }
          />
          <Route
            path="/tasks/:type"
            element={
              <AuthenticateRoute>
                <TasksList />
              </AuthenticateRoute>
            }
          />

          <Route
            path="/task-detail"
            element={
              <AuthenticateRoute>
                <Detail />
              </AuthenticateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
